export default __webpack_public_path__ + "static/media/default_parking_video_img.ca39d3e9.jpg";